<!-- @prettier -->
<template>
	<div>
		<strong>Breaks</strong>
		<ul class="hours-operation__breaks-list">
			<li v-for="(breakItem, index) in breaks" :key="index">
				{{
					breakStartTime(breakItem.startTime.hour, breakItem.startTime.minute)
				}}
				for {{ breakItem.lengthInMin }} minutes
				<button v-if="!disabled" class="cf-node__action m-l-5" @click="removeBreak(index)">
					<i class="fa fa-trash" aria-hidden="true" />
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'HoursOfOperationBreaks',
	props: {
		breaks: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			}
		}
	},
	methods: {
		breakStartTime(hour, minute) {
			const timeMoment = moment(`${hour}:${minute}`, 'H:m');
			return `${timeMoment.format('hh')}:${timeMoment.format(
				'mm'
			)} ${timeMoment.format('A')}`;
		},
		removeBreak(index) {
			this.$emit('remove-break', index);
		}
	}
};
</script>
